export default __webpack_public_path__ + "static/media/arrow-right.74334e7f.svg";